import { Text, type TextProps } from '@chakra-ui/react';
import { type HTMLMotionProps, motion } from 'framer-motion';
import type { ComponentType } from 'react';

export type MotionTextProps = Omit<
  TextProps,
  keyof HTMLMotionProps<'span'> | 'transition'
> &
  HTMLMotionProps<'span'>;

export const MotionText = motion.create(Text) as ComponentType<MotionTextProps>;
